import utilities from './utilities';

// ==============================|| MENU ITEMS ||============================== //
const menuTechnical = {
  items: [utilities],
};

export default menuTechnical;
